import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { onHomepageData } from './action';

export default function Index() {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.SlidersData.allData)

  useEffect(() => {
    if (!products.length > 0) {
        dispatch(onHomepageData());
    }
  }, [dispatch, products.length]);
}